import React, { lazy } from 'react';
import { pageUrls } from 'globalconfig/constants/keys';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));

const AdvancedDvir = ({ className, label, history }) => {
  return (
    <Button
      type="submit"
      className={className}
      label={label}
      onClick={() => {
        history.push(pageUrls.advancedDvirEnabled);
      }}
    />
  );
};

export default AdvancedDvir;
